import React, { useState, useEffect } from 'react'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'

import { useDailyBilling } from './hooks/useDailyBilling'
import { getDaysInMonth, mergeDaysWithValues } from '../../../../utils/constants'
import { functionalitiesHelper, isSameOrBeforeDate } from '../../../../utils/functionalitiesHelper'
import { capitalize, formatDate, formatMoney } from '../../../../utils/formatters'

import { CAMPAIGN_TEXT, INITIAL_VALUE, ITEMS_PER_PAGE, COUPON_TEXT } from './constants'

import Alert from '../../../../components/Form/Alert'
import BackButton from '../../../../components/BackButton'
import DateHeader from '../components/DateHeader'
import ExpandableCard from '../../../../components/Card/ExpandableCard'
import { ReactComponent as InvoicingIcon } from '../../../../assets/icons/invoicing.svg'
import { ReactComponent as InvoicingGrayIcon } from '../../../../assets/icons/invoicing_gray.svg'

import * as S from './styles'

const DailyBilling = () => {
  const { getDates } = functionalitiesHelper
  const { search } = useLocation()
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const { date, sameDate } = queryString.parse(search, { parseBooleans: true })
  const { monthAndYear, day, month, year, fullDate } = getDates(date)
  const billingData = useDailyBilling(professional.id, fullDate, sameDate)
  const loading = !billingData
  const daysWithoutValues = getDaysInMonth(month, year)
  const [displayedItems, setdisplayedItems] = useState(ITEMS_PER_PAGE)
  const [detailedDays, setDetailedDays] = useState([])
  const header = {
    title: monthAndYear,
    subtitle: `Informações ${sameDate ? 'deste mês ' : ''} até o dia ${day}`,
    loading
  }

  useEffect(() => {
    if (detailedDays.length <= 0 && billingData) {
      const mergedDays = billingData && mergeDaysWithValues(daysWithoutValues, billingData)
      if (sameDate) {
        const filteredCurrentDate = isSameOrBeforeDate(mergedDays, date)
        return setDetailedDays(filteredCurrentDate)
      }
      setDetailedDays(mergedDays)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingData])

  const handleLoadMore = () => {
    setdisplayedItems(prevItems => prevItems + ITEMS_PER_PAGE)
  }

  return (
    <>
      <BackButton text='Faturamento diário' />
      <S.Container>
        <DateHeader {...header} />
        {loading && Array(ITEMS_PER_PAGE).fill().map((_, index) => <S.SkeletonCard type='card' key={'fill-' + index} />)}
        {detailedDays && detailedDays.slice(INITIAL_VALUE, displayedItems).map((item, index) => {
          const hasDailyBilling = 'amounts' in item
          const itemDay = formatDate({ date: item.day, format: 'DD' })
          const sameDay = day === itemDay

          return <S.CardContainer key={'day-' + index}>
            <ExpandableCard full icon={hasDailyBilling ? <InvoicingIcon /> : <InvoicingGrayIcon />} title={`Dia ${itemDay}`} subtitle={capitalize(formatDate({ date: item.day, format: 'dddd' }))}>
              <S.Block>
                <hr />
                {item.campaign && item.campaign.length > 0 &&
                  <S.BoxAlert>
                    <Alert type='campaign' show>
                      {CAMPAIGN_TEXT(sameDate, sameDay, item.campaign)}
                    </Alert>
                  </S.BoxAlert>
                }
                {item.schedulingCoupon && item.schedulingCoupon.length > 0 &&
                 <S.BoxAlert>
                   <Alert type='campaign' show>
                     {COUPON_TEXT(sameDate, sameDay, item.schedulingCoupon)}
                   </Alert>
                 </S.BoxAlert>
                }
                <S.BlockFlex>
                  {hasDailyBilling
                    ? <>
                      <S.EarningsOfTheDay isDisabled={item.amounts.professional === 0}>{formatMoney(item.amounts.professional)}</S.EarningsOfTheDay>
                      <S.Text>são de atendimentos realizados pelo <strong>profissional principal</strong></S.Text>
                      <S.EarningsOfTheDay isDisabled={item.amounts.freelancers === 0}>{formatMoney(item.amounts.freelancers)}</S.EarningsOfTheDay>
                      <S.Text>são de atendimentos realizados pelos <strong>profissionais substitutos</strong></S.Text>
                      <hr />
                      <S.TotalEarnings>{formatMoney(item.amounts.total)} de faturamento bruto</S.TotalEarnings>
                    </>
                    : <>
                      {sameDate && item.day === date
                        ? <>
                          <S.EarningsOfTheDay isDisabled>R$0 de faturamento até o momento</S.EarningsOfTheDay>
                          <S.Text isDisabled>Hoje ainda não foi finalizado nenhum agendamento ou encaixe.</S.Text>
                        </>
                        : <>
                          <S.EarningsOfTheDay isDisabled>R$0 de faturamento nesse dia</S.EarningsOfTheDay>
                          <S.Text isDisabled>Nesse dia não foi realizado nenhum agendamento ou encaixe.</S.Text>
                        </>
                      }
                    </>
                  }
                </S.BlockFlex>
              </S.Block>
            </ExpandableCard>
          </S.CardContainer>
        })}
        {displayedItems < detailedDays.length && (
          <S.LoadMoreButton onClick={handleLoadMore} outline>Carregar mais</S.LoadMoreButton>
        )}
      </S.Container>
    </>
  )
}

export default DailyBilling
